import { useState, useCallback, useRef } from "react";

// ─── MD5 (pure JS) ────────────────────────────────────────────────────────────
function md5(str) {
  function safeAdd(x, y) { const lsw=(x&0xFFFF)+(y&0xFFFF); const msw=(x>>16)+(y>>16)+(lsw>>16); return (msw<<16)|(lsw&0xFFFF); }
  function bitRotateLeft(num, cnt) { return (num<<cnt)|(num>>>(32-cnt)); }
  function md5cmn(q,a,b,x,s,t2) { return safeAdd(bitRotateLeft(safeAdd(safeAdd(a,q),safeAdd(x,t2)),s),b); }
  function md5ff(a,b,c,d,x,s,t2) { return md5cmn((b&c)|((~b)&d),a,b,x,s,t2); }
  function md5gg(a,b,c,d,x,s,t2) { return md5cmn((b&d)|(c&(~d)),a,b,x,s,t2); }
  function md5hh(a,b,c,d,x,s,t2) { return md5cmn(b^c^d,a,b,x,s,t2); }
  function md5ii(a,b,c,d,x,s,t2) { return md5cmn(c^(b|(~d)),a,b,x,s,t2); }
  function strToUTF8Arr(s) {
    const a=[]; for(let i=0;i<s.length;i++){const c=s.charCodeAt(i);if(c<128)a.push(c);else if(c<2048){a.push(192|(c>>6));a.push(128|(c&63));}else{a.push(224|(c>>12));a.push(128|((c>>6)&63));a.push(128|(c&63));}}
    return a;
  }
  const utf8=strToUTF8Arr(str),len=utf8.length,nblocks=((len+8)>>6)+1,blks=new Array(nblocks*16).fill(0);
  for(let i=0;i<len;i++) blks[i>>2]|=utf8[i]<<((i%4)*8);
  blks[len>>2]|=0x80<<((len%4)*8); blks[nblocks*16-2]=len*8;
  let a=1732584193,b=-271733879,c=-1732584194,d=271733878;
  for(let i=0;i<nblocks*16;i+=16){
    const aa=a,bb=b,cc=c,dd=d;
    a=md5ff(a,b,c,d,blks[i],7,-680876936);d=md5ff(d,a,b,c,blks[i+1],12,-389564586);c=md5ff(c,d,a,b,blks[i+2],17,606105819);b=md5ff(b,c,d,a,blks[i+3],22,-1044525330);
    a=md5ff(a,b,c,d,blks[i+4],7,-176418897);d=md5ff(d,a,b,c,blks[i+5],12,1200080426);c=md5ff(c,d,a,b,blks[i+6],17,-1473231341);b=md5ff(b,c,d,a,blks[i+7],22,-45705983);
    a=md5ff(a,b,c,d,blks[i+8],7,1770035416);d=md5ff(d,a,b,c,blks[i+9],12,-1958414417);c=md5ff(c,d,a,b,blks[i+10],17,-42063);b=md5ff(b,c,d,a,blks[i+11],22,-1990404162);
    a=md5ff(a,b,c,d,blks[i+12],7,1804603682);d=md5ff(d,a,b,c,blks[i+13],12,-40341101);c=md5ff(c,d,a,b,blks[i+14],17,-1502002290);b=md5ff(b,c,d,a,blks[i+15],22,1236535329);
    a=md5gg(a,b,c,d,blks[i+1],5,-165796510);d=md5gg(d,a,b,c,blks[i+6],9,-1069501632);c=md5gg(c,d,a,b,blks[i+11],14,643717713);b=md5gg(b,c,d,a,blks[i],20,-373897302);
    a=md5gg(a,b,c,d,blks[i+5],5,-701558691);d=md5gg(d,a,b,c,blks[i+10],9,38016083);c=md5gg(c,d,a,b,blks[i+15],14,-660478335);b=md5gg(b,c,d,a,blks[i+4],20,-405537848);
    a=md5gg(a,b,c,d,blks[i+9],5,568446438);d=md5gg(d,a,b,c,blks[i+14],9,-1019803690);c=md5gg(c,d,a,b,blks[i+3],14,-187363961);b=md5gg(b,c,d,a,blks[i+8],20,1163531501);
    a=md5gg(a,b,c,d,blks[i+13],5,-1444681467);d=md5gg(d,a,b,c,blks[i+2],9,-51403784);c=md5gg(c,d,a,b,blks[i+7],14,1735328473);b=md5gg(b,c,d,a,blks[i+12],20,-1926607734);
    a=md5hh(a,b,c,d,blks[i+5],4,-378558);d=md5hh(d,a,b,c,blks[i+8],11,-2022574463);c=md5hh(c,d,a,b,blks[i+11],16,1839030562);b=md5hh(b,c,d,a,blks[i+14],23,-35309556);
    a=md5hh(a,b,c,d,blks[i+1],4,-1530992060);d=md5hh(d,a,b,c,blks[i+4],11,1272893353);c=md5hh(c,d,a,b,blks[i+7],16,-155497632);b=md5hh(b,c,d,a,blks[i+10],23,-1094730640);
    a=md5hh(a,b,c,d,blks[i+13],4,681279174);d=md5hh(d,a,b,c,blks[i],11,-358537222);c=md5hh(c,d,a,b,blks[i+3],16,-722521979);b=md5hh(b,c,d,a,blks[i+6],23,76029189);
    a=md5hh(a,b,c,d,blks[i+9],4,-640364487);d=md5hh(d,a,b,c,blks[i+12],11,-421815835);c=md5hh(c,d,a,b,blks[i+15],16,530742520);b=md5hh(b,c,d,a,blks[i+2],23,-995338651);
    a=md5ii(a,b,c,d,blks[i],6,-198630844);d=md5ii(d,a,b,c,blks[i+7],10,1126891415);c=md5ii(c,d,a,b,blks[i+14],15,-1416354905);b=md5ii(b,c,d,a,blks[i+5],21,-57434055);
    a=md5ii(a,b,c,d,blks[i+12],6,1700485571);d=md5ii(d,a,b,c,blks[i+3],10,-1894986606);c=md5ii(c,d,a,b,blks[i+10],15,-1051523);b=md5ii(b,c,d,a,blks[i+1],21,-2054922799);
    a=md5ii(a,b,c,d,blks[i+8],6,1873313359);d=md5ii(d,a,b,c,blks[i+15],10,-30611744);c=md5ii(c,d,a,b,blks[i+6],15,-1560198380);b=md5ii(b,c,d,a,blks[i+13],21,1309151649);
    a=md5ii(a,b,c,d,blks[i+4],6,-145523070);d=md5ii(d,a,b,c,blks[i+11],10,-1120210379);c=md5ii(c,d,a,b,blks[i+2],15,718787259);b=md5ii(b,c,d,a,blks[i+9],21,-343485551);
    a=safeAdd(a,aa);b=safeAdd(b,bb);c=safeAdd(c,cc);d=safeAdd(d,dd);
  }
  return [a,b,c,d].map(n=>{let h="";for(let i=0;i<4;i++)h+=("0"+((n>>(i*8+4))&0xF).toString(16)).slice(-1)+("0"+((n>>(i*8))&0xF).toString(16)).slice(-1);return h;}).join("");
}

// ─── SHA via Web Crypto ────────────────────────────────────────────────────────
async function shaHash(text, algo) {
  const data = new TextEncoder().encode(text);
  const buf  = await crypto.subtle.digest(algo, data);
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,"0")).join("");
}

async function shaFileHash(arrayBuffer, algo) {
  const buf = await crypto.subtle.digest(algo, arrayBuffer);
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,"0")).join("");
}

function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes/1024).toFixed(1)} KB`;
  return `${(bytes/1048576).toFixed(1)} MB`;
}

// ─── COPY BUTTON ─────────────────────────────────────────────────────────────
function CopyBtn({ text, t }) {
  const [copied, setCopied] = useState(false);
  return (
    <button className="btn-sm" onClick={() => navigator.clipboard.writeText(text).then(()=>{setCopied(true);setTimeout(()=>setCopied(false),1600);})}
      style={{ borderColor:copied?t.statusOk:t.border, color:copied?t.statusOk:t.textMuted }}>
      {copied ? "✓ Copied" : "⎘ Copy"}
    </button>
  );
}

// ─── HASH RESULT ROW ─────────────────────────────────────────────────────────
function HashRow({ label, bits, value, t }) {
  return (
    <div className="panel" style={{ marginBottom:8 }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"7px 12px", background:t.bgPanelHead, borderBottom:`1px solid ${t.border}` }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em", color:t.textAccent }}>{label}</span>
          <span className="pill pill-blue" style={{ fontSize:9 }}>{bits}-bit</span>
        </div>
        {value && <CopyBtn text={value} t={t} />}
      </div>
      <div style={{ padding:"10px 14px", fontFamily:"JetBrains Mono", fontSize:12, color: value ? t.textSecondary : t.textMuted, wordBreak:"break-all", letterSpacing:"0.04em" }}>
        {value || <span style={{ fontStyle:"italic" }}>—</span>}
      </div>
    </div>
  );
}

// ─── TEXT HASH TOOL ───────────────────────────────────────────────────────────
function TextHasher({ t }) {
  const [input, setInput]     = useState("Hello, miniDevToolkit!");
  const [hashes, setHashes]   = useState({ md5:"", sha256:"", sha512:"" });
  const [loading, setLoading] = useState(false);

  const compute = useCallback(async () => {
    if (!input.trim()) { setHashes({ md5:"", sha256:"", sha512:"" }); return; }
    setLoading(true);
    try {
      const [h256, h512] = await Promise.all([
        shaHash(input, "SHA-256"),
        shaHash(input, "SHA-512"),
      ]);
      setHashes({ md5: md5(input), sha256: h256, sha512: h512 });
    } finally { setLoading(false); }
  }, [input]);

  const allHashes = hashes.md5 ?
    `MD5:    ${hashes.md5}\nSHA-256: ${hashes.sha256}\nSHA-512: ${hashes.sha512}` : "";

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
      <div style={{ background:t.bgChipActive, border:`1px solid ${t.border}`, borderRadius:10, padding:"10px 14px", fontSize:13, color:t.textSecondary, display:"flex", alignItems:"center", gap:8 }}>
        <span style={{ fontSize:16, flexShrink:0 }}>ℹ</span>
        Hash functions are one-way — you cannot reverse a hash back to the original text.
      </div>

      <div className="panel" style={{ border:`1px solid ${input.trim() ? t.borderActive : t.border}` }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:t.bgPanelHead, borderBottom:`1px solid ${t.border}` }}>
          <span style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em", color:t.textAccent }}>Input Text</span>
          <button className="btn-sm" onClick={() => { setInput(""); setHashes({ md5:"", sha256:"", sha512:"" }); }}>Clear</button>
        </div>
        <textarea value={input} onChange={e => setInput(e.target.value)} placeholder="Type or paste text to hash…" spellCheck={false}
          style={{ width:"100%", height:120, background:"transparent", border:"none", outline:"none", padding:"12px 14px", color:t.textPrimary, fontFamily:"JetBrains Mono, monospace", fontSize:13, lineHeight:1.7, resize:"none" }} />
        <div style={{ padding:"8px 14px", borderTop:`1px solid ${t.border}`, display:"flex", alignItems:"center", gap:8 }}>
          <button className="btn-primary" onClick={compute} disabled={!input.trim() || loading} style={{ padding:"7px 20px", fontSize:12 }}>
            {loading ? "⏳ Computing…" : "# Compute All Hashes"}
          </button>
          {hashes.md5 && <CopyBtn text={allHashes} t={t} />}
          <span style={{ fontSize:11, color:t.textMuted, fontFamily:"JetBrains Mono" }}>{input.length} chars · {new Blob([input]).size} bytes</span>
        </div>
      </div>

      <HashRow label="MD5"    bits={128}  value={hashes.md5}    t={t} />
      <HashRow label="SHA-256" bits={256}  value={hashes.sha256} t={t} />
      <HashRow label="SHA-512" bits={512}  value={hashes.sha512} t={t} />
    </div>
  );
}

// ─── SHA-256 DEDICATED ────────────────────────────────────────────────────────
function SHA256Tool({ t }) {
  const [input, setInput]   = useState("");
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);
  const [uppercase, setUppercase] = useState(false);

  const compute = useCallback(async () => {
    if (!input.trim()) { setOutput(""); return; }
    setLoading(true);
    try {
      const hash = await shaHash(input, "SHA-256");
      setOutput(uppercase ? hash.toUpperCase() : hash);
    } finally { setLoading(false); }
  }, [input, uppercase]);

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
      <div style={{ display:"flex", gap:8, alignItems:"center" }}>
        <div onClick={() => setUppercase(v => !v)} style={{ display:"flex", alignItems:"center", gap:7, background:t.bgSettingGrp, border:`1px solid ${t.border}`, borderRadius:10, padding:"6px 12px", cursor:"pointer" }}>
          <div className={`toggle ${uppercase?"on":""}`}><div className="toggle-thumb"/></div>
          <span style={{ fontSize:11, color:t.textLabel, fontFamily:"JetBrains Mono" }}>Uppercase output</span>
        </div>
      </div>
      <div className="grid-2">
        <div className="panel" style={{ border:`1px solid ${input.trim()?t.borderActive:t.border}` }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:t.bgPanelHead, borderBottom:`1px solid ${t.border}` }}>
            <span style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em", color:t.textAccent }}>Input</span>
            <button className="btn-sm" onClick={() => { setInput(""); setOutput(""); }}>Clear</button>
          </div>
          <textarea value={input} onChange={e => setInput(e.target.value)} placeholder="Type text to hash…" spellCheck={false}
            style={{ width:"100%", height:200, background:"transparent", border:"none", outline:"none", padding:"12px 14px", color:t.textPrimary, fontFamily:"JetBrains Mono, monospace", fontSize:12, lineHeight:1.7, resize:"none" }} />
          <div style={{ padding:"8px 14px", borderTop:`1px solid ${t.border}` }}>
            <button className="btn-primary" onClick={compute} disabled={!input.trim()||loading} style={{ padding:"6px 18px", fontSize:12 }}>
              {loading ? "⏳…" : "Hash →"}
            </button>
          </div>
        </div>
        <div className="panel active-panel">
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:t.bgPanelHead, borderBottom:`1px solid ${t.border}` }}>
            <span style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em", color:t.textAccent }}>SHA-256 Hash <span className="pill pill-blue" style={{ fontSize:9, marginLeft:6 }}>256-bit</span></span>
            {output && <CopyBtn text={output} t={t} />}
          </div>
          <div style={{ padding:"16px 14px", fontFamily:"JetBrains Mono", fontSize:13, color:output?t.textSecondary:t.textMuted, wordBreak:"break-all", letterSpacing:"0.05em", lineHeight:1.7, minHeight:120 }}>
            {output || <span style={{ fontStyle:"italic", fontSize:12 }}>SHA-256 hash appears here…</span>}
          </div>
          {output && <div style={{ padding:"6px 14px", borderTop:`1px solid ${t.border}`, fontSize:11, fontFamily:"JetBrains Mono", color:t.statusOk }}>64 hex characters · 256 bits</div>}
        </div>
      </div>
    </div>
  );
}

// ─── SHA-512 DEDICATED ────────────────────────────────────────────────────────
function SHA512Tool({ t }) {
  const [input, setInput]   = useState("");
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);
  const [uppercase, setUppercase] = useState(false);

  const compute = useCallback(async () => {
    if (!input.trim()) { setOutput(""); return; }
    setLoading(true);
    try {
      const hash = await shaHash(input, "SHA-512");
      setOutput(uppercase ? hash.toUpperCase() : hash);
    } finally { setLoading(false); }
  }, [input, uppercase]);

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
      <div style={{ display:"flex", gap:8, alignItems:"center" }}>
        <div onClick={() => setUppercase(v => !v)} style={{ display:"flex", alignItems:"center", gap:7, background:t.bgSettingGrp, border:`1px solid ${t.border}`, borderRadius:10, padding:"6px 12px", cursor:"pointer" }}>
          <div className={`toggle ${uppercase?"on":""}`}><div className="toggle-thumb"/></div>
          <span style={{ fontSize:11, color:t.textLabel, fontFamily:"JetBrains Mono" }}>Uppercase output</span>
        </div>
      </div>
      <div className="grid-2">
        <div className="panel" style={{ border:`1px solid ${input.trim()?t.borderActive:t.border}` }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:t.bgPanelHead, borderBottom:`1px solid ${t.border}` }}>
            <span style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em", color:t.textAccent }}>Input</span>
            <button className="btn-sm" onClick={() => { setInput(""); setOutput(""); }}>Clear</button>
          </div>
          <textarea value={input} onChange={e => setInput(e.target.value)} placeholder="Type text to hash…" spellCheck={false}
            style={{ width:"100%", height:200, background:"transparent", border:"none", outline:"none", padding:"12px 14px", color:t.textPrimary, fontFamily:"JetBrains Mono, monospace", fontSize:12, lineHeight:1.7, resize:"none" }} />
          <div style={{ padding:"8px 14px", borderTop:`1px solid ${t.border}` }}>
            <button className="btn-primary" onClick={compute} disabled={!input.trim()||loading} style={{ padding:"6px 18px", fontSize:12 }}>
              {loading ? "⏳…" : "Hash →"}
            </button>
          </div>
        </div>
        <div className="panel active-panel">
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:t.bgPanelHead, borderBottom:`1px solid ${t.border}` }}>
            <span style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em", color:t.textAccent }}>SHA-512 Hash <span className="pill pill-blue" style={{ fontSize:9, marginLeft:6 }}>512-bit</span></span>
            {output && <CopyBtn text={output} t={t} />}
          </div>
          <div style={{ padding:"16px 14px", fontFamily:"JetBrains Mono", fontSize:12, color:output?t.textSecondary:t.textMuted, wordBreak:"break-all", letterSpacing:"0.04em", lineHeight:1.8, minHeight:120 }}>
            {output || <span style={{ fontStyle:"italic" }}>SHA-512 hash appears here…</span>}
          </div>
          {output && <div style={{ padding:"6px 14px", borderTop:`1px solid ${t.border}`, fontSize:11, fontFamily:"JetBrains Mono", color:t.statusOk }}>128 hex characters · 512 bits</div>}
        </div>
      </div>
    </div>
  );
}

// ─── FILE HASH TOOL ───────────────────────────────────────────────────────────
function FileHasher({ t }) {
  const [file, setFile]       = useState(null);
  const [hashes, setHashes]   = useState(null);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState("");
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef(null);

  const processFile = useCallback(async (f) => {
    if (!f) return;
    setFile(f);
    setHashes(null);
    setLoading(true);
    setProgress("Reading file…");
    try {
      const buf = await f.arrayBuffer();
      setProgress("Computing MD5…");
      const text = new TextDecoder("utf-8", { fatal:false }).decode(buf);
      const md5hash = md5(text);
      setProgress("Computing SHA-256…");
      const sha256hash = await shaFileHash(buf, "SHA-256");
      setProgress("Computing SHA-512…");
      const sha512hash = await shaFileHash(buf, "SHA-512");
      setHashes({ md5: md5hash, sha256: sha256hash, sha512: sha512hash });
      setProgress("");
    } catch(e) {
      setProgress("Error: " + e.message);
    } finally { setLoading(false); }
  }, []);

  const onDrop = e => {
    e.preventDefault(); setDragOver(false);
    const f = e.dataTransfer.files[0];
    if (f) processFile(f);
  };

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
      <div style={{ background:t.bgChipActive, border:`1px solid ${t.border}`, borderRadius:10, padding:"10px 14px", fontSize:13, color:t.textSecondary, display:"flex", alignItems:"center", gap:8 }}>
        <span style={{ fontSize:16 }}>🔒</span>
        File hashing runs entirely in your browser — your file is never uploaded to any server.
      </div>

      {/* Drop zone */}
      <div style={{ border:`2px dashed ${dragOver ? t.borderActive : file ? t.borderActive : t.dragBorder}`, borderRadius:14, background:dragOver?t.bgChipActive:t.dragBg, padding:"2.5rem 1.5rem", textAlign:"center", cursor:"pointer", transition:"all 0.2s", color:dragOver?t.textAccent:file?t.textAccent:t.dragText }}
        onDragOver={e=>{e.preventDefault();setDragOver(true);}} onDragLeave={()=>setDragOver(false)} onDrop={onDrop}
        onClick={()=>fileRef.current?.click()}>
        <div style={{ fontSize:36, marginBottom:8 }}>{file ? "✓" : "📁"}</div>
        {file ? (
          <div>
            <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>{file.name}</div>
            <div style={{ fontSize:12, color:t.textMuted }}>{formatBytes(file.size)} · {file.type || "unknown type"}</div>
          </div>
        ) : (
          <div>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:4 }}>Drop any file here to hash it</div>
            <div style={{ fontSize:12 }}>or <strong style={{ color:t.textAccent }}>click to browse</strong> · any file type accepted</div>
          </div>
        )}
        <input ref={fileRef} type="file" style={{ display:"none" }} onChange={e => processFile(e.target.files[0])} />
      </div>

      {loading && (
        <div style={{ background:t.bgChipActive, border:`1px solid ${t.borderActive}`, borderRadius:10, padding:"12px 16px", fontSize:13, color:t.textAccent, display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ animation:"spin 1s linear infinite", display:"inline-block" }}>⟳</span>
          {progress}
        </div>
      )}

      {hashes && !loading && (
        <div>
          <HashRow label="MD5"     bits={128} value={hashes.md5}    t={t} />
          <HashRow label="SHA-256" bits={256} value={hashes.sha256} t={t} />
          <HashRow label="SHA-512" bits={512} value={hashes.sha512} t={t} />
          <div style={{ marginTop:8, padding:"10px 14px", background:t.bgPanel, border:`1px solid ${t.border}`, borderRadius:10, fontSize:12, color:t.textMuted, fontFamily:"JetBrains Mono" }}>
            File: {file.name} · {formatBytes(file.size)} · Hashed at {new Date().toLocaleTimeString()}
          </div>
        </div>
      )}
      <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const TOOLS = [
  { id:"all",     label:"All Hashes",    icon:"#",  desc:"MD5 + SHA-256 + SHA-512 at once" },
  { id:"sha256",  label:"SHA-256",       icon:"🔐", desc:"256-bit secure hash" },
  { id:"sha512",  label:"SHA-512",       icon:"🔒", desc:"512-bit secure hash" },
  { id:"file",    label:"File Hash",     icon:"📁", desc:"Hash any file in your browser" },
];

export default function HashToolkit({ t }) {
  const [active, setActive] = useState("all");

  const components = {
    all:    <TextHasher t={t} />,
    sha256: <SHA256Tool t={t} />,
    sha512: <SHA512Tool t={t} />,
    file:   <FileHasher t={t} />,
  };

  return (
    <div>
      <div className="tool-hero fade-up">
        <div className="tool-hero-inner">
          <div className="tool-hero-left">
            <h2># Hash & Security Tools</h2>
            <p>MD5, SHA-256, SHA-512 hash generators for text and files. All hashing runs in your browser using the Web Crypto API.</p>
          </div>
          <div className="tool-hero-stats">
            <div className="tool-stat"><div className="tool-stat-val">4</div><div className="tool-stat-lbl">tools</div></div>
            <div className="tool-stat"><div className="tool-stat-val">3</div><div className="tool-stat-lbl">algorithms</div></div>
            <div className="tool-stat"><div className="tool-stat-val">0</div><div className="tool-stat-lbl">server calls</div></div>
          </div>
        </div>
      </div>

      <div className="pill-tab-bar" style={{ display:"flex", gap:6, padding:"12px 16px", flexWrap:"wrap" }}>
        {TOOLS.map(tool => {
          const isActive = active === tool.id;
          return (
            <button key={tool.id} onClick={() => setActive(tool.id)}
              className={`pill-tab ${isActive ? "active" : ""}`}>
              <span>{tool.icon}</span>{tool.label}
            </button>
          );
        })}
      </div>

      <div className="tool-main">
        {components[active]}
      </div>

      {/* On-page SEO */}
      <article className="tool-seo-section" aria-label="About Hash & Security Tools">
        <h2>About Hash &amp; Security Tools</h2>
        <div className="tool-seo-cols">
          <div>
            <h3>How it works</h3>
            <ul>
              <li>MD5 is computed via a pure-JS implementation for maximum compatibility.</li>
              <li>SHA-256 and SHA-512 use the browser's native <strong>Web Crypto API</strong>.</li>
              <li>File hashing reads the file as an ArrayBuffer entirely in your browser.</li>
              <li>Zero bytes leave your device — no server calls, ever.</li>
            </ul>
          </div>
          <div>
            <h3>Use cases</h3>
            <ul>
              <li>Verify file integrity before deployment.</li>
              <li>Generate checksums for downloads.</li>
              <li>Compare strings to detect tampering.</li>
              <li>Quickly hash API secrets or tokens for debugging.</li>
            </ul>
          </div>
          <div>
            <h3>Privacy</h3>
            <ul>
              <li>All hashing runs 100% in your browser.</li>
              <li>No text or files are sent to any server.</li>
              <li>No account required — open and use immediately.</li>
            </ul>
          </div>
        </div>
        <h2 style={{ marginTop:"1.5rem" }}>Frequently Asked Questions</h2>
        <details><summary>What is the difference between MD5, SHA-256, and SHA-512?</summary><p>MD5 produces a 128-bit (32 hex character) hash and is fast but not collision-resistant — avoid it for security-critical uses. SHA-256 produces 256 bits (64 hex chars) and is widely used in security and blockchain. SHA-512 produces 512 bits (128 hex chars) and offers the strongest resistance of the three.</p></details>
        <details><summary>Can I reverse a hash back to the original text?</summary><p>No. Hash functions are one-way — it is computationally infeasible to reverse a hash to its input. This is by design; hashes are used to verify integrity, not store retrievable data.</p></details>
        <details><summary>Is my file uploaded when I use the File Hash tool?</summary><p>No. The File Hash tool reads your file directly in the browser using the File API and Web Crypto API. Nothing is sent over the network. You can even use it with your network connection disabled.</p></details>
        <details><summary>Why do my MD5 results differ from other tools?</summary><p>Ensure you are hashing the exact same content with the same encoding. Line-ending differences (CRLF vs LF) and trailing whitespace are common causes of mismatched hashes.</p></details>
        <details><summary>Does the hash tool work offline?</summary><p>Yes. Text hashing uses the browser's built-in Web Crypto API (for SHA-256 and SHA-512) and a pure-JavaScript MD5 implementation — no server calls are made. File hashing also works offline via the File API.</p></details>
        <h2 style={{ marginTop:"1.5rem" }}>Alternatives &amp; why miniDevToolkit</h2>
        <p>Compared to <strong>MD5 Hash Generator sites</strong> — these are typically single-algorithm tools. miniDevToolkit computes MD5, SHA-256, and SHA-512 simultaneously in the "All Hashes" tab, saving you multiple visits. Compared to <strong>CyberChef</strong> — miniDevToolkit has a focused hash UI with uppercase toggle and file drag-and-drop, with no recipe configuration needed. Compared to <strong>dcode.fr</strong> — miniDevToolkit adds SHA-512 and file hashing (dcode.fr's file hashing uploads the file to a server; miniDevToolkit does not). All hashing is strictly client-side and verifiable via DevTools.</p>
      </article>
    </div>
  );
}